<mat-toolbar>
  <mat-toolbar-row>
    <!-- Left Side: burger + logo + small network icon button -->
    <div class="left-side">
      <button mat-icon-button (click)="toggleSideBar()" aria-label="Toggle menu">
        <mat-icon>menu</mat-icon>
      </button>

      <div class="brand">
        <a class="logo" routerLink="/" aria-label="TradeLayer Home">
          <img src="assets/tl-logo.svg" alt="TradeLayer" />
        </a>

        <!-- coin button right of logo -->
        <button
          mat-icon-button
          class="network-btn"
          aria-label="Switch network"
          (click)="openNetworkDialog()"
          title="Switch network"
        >
          <img [src]="networkIcon" alt="Network" />
        </button>
      </div>
    </div>

    <span class="spacer"></span>

    <!-- Right Side: Wallet and Balance Information (unchanged) -->
    <div class="right-side">
      <div id="wallet-ui">
        <!-- Download TL Wallet Button -->
        <button
          id="download-wallet-btn"
          class="download-wallet-btn"
          *ngIf="!walletAddress"
          (click)="openWalletDownload()"
        >
          Download TL Wallet
        </button>

        <!-- Connect Wallet Button -->
        <button
            id="connectWalletButton"
            class="connect-button"
            *ngIf="!walletAddress"
            (click)="connectWallet()"
          >
          CONNECT WALLET
          <img
            *ngIf="isBitcoinNetwork"
            class="phantom-coin"
            src="assets/icons/Phantom_SVG_Icon.svg"
            alt="Phantom"
          />
          <img
            *ngIf="isLitecoinNetwork"
            class="phantom-coin"
            src="assets/icons/tl_logo_circle_only_small.png"
            alt="TL Wallet"
          />
        </button>

        <!-- Wallet Info Display -->
        <div id="wallet-info" *ngIf="walletAddress" class="wallet-address-display">
          Connected:
          <span id="connectedAddress">
            {{ walletAddress | slice:0:6 }}...{{ walletAddress | slice:-6 }}
          </span>
        </div>
      </div>
    </div>
  </mat-toolbar-row>
</mat-toolbar>

<!-- Tabs -->
<div class="nav-container">
  <nav mat-tab-nav-bar mat-align-tabs="center">
    <a
      *ngFor="let route of mainRoutes"
      mat-tab-link
      (click)="navigateTo(route)"
      [active]="selectedRoute === route"
      [disabled]="route.disabled"
    >
      {{ route.name }}
    </a>
  </nav>
</div>
